const TimeSlice = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
  QUATERLY: 'QUATERLY',
  YEARLY: 'YEARLY',
};
export default TimeSlice;

export const TimeSliceEntity = {
  [TimeSlice.DAILY]: {
    label: 'Daily',
    value: TimeSlice.DAILY,
  },
  [TimeSlice.MONTHLY]: {
    label: 'Monthly',
    value: TimeSlice.MONTHLY,
  },
  [TimeSlice.QUATERLY]: {
    label: 'Quaterly',
    value: TimeSlice.QUATERLY,
  },
  [TimeSlice.YEARLY]: {
    label: 'Yearly',
    value: TimeSlice.YEARLY,
  },
};

export const timeSliceOptions = Object.entries(TimeSliceEntity).map(
  ([key, entity]) => ({
    label: entity.label,
    value: key,
  })
);
